function formatEquip(equip) {
  return `- [${equip.targetName}](${equip.reportUrl}) \n\n ${equip.ruleName}`;
}

export function formatEquipList(equipList = []) {
  return equipList.map((equip) => formatEquip(equip)).join("\n");
}
